var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSelectArrow = function SvgSelectArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Polygon 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19 0 0h22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 16.006 19.398 1.5H2.602L11 16.006M11 19 0 0h22L11 19z"
  }))));
};
export { SvgSelectArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMiAxOSI+CiAgPGcgZGF0YS1uYW1lPSJQb2x5Z29uIDE2IiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik0xMSAxOUwwIDBoMjJ6Ii8+CiAgICA8cGF0aCBkPSJNMTEgMTYuMDA2TDE5LjM5OCAxLjVIMi42MDJMMTEgMTYuMDA2TTExIDE5TDAgMGgyMkwxMSAxOXoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogIDwvZz4KPC9zdmc+";